<h1 mat-dialog-title>Dialog with elements</h1>
<div mat-dialog-content>
    <mat-card class='cardMarginBottom' [formGroup]="dynamicForm">
        <div class='row m-2'>
            <div fxLayout="row">
                <div class="selected-project">Catalogo</div>
            </div>
        </div>

        <div class="row text-center" >

            <div class="col-sm-12 col-md-12 col-xl-12">
                <div class='bordeFirma'>
                    <label>Nombre:</label>
                    <input type="text" formControlName="nombre">
                </div>
            </div>


        </div>

    </mat-card>

</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancelar</button>
    <div class="row" >
        <div class="col-sm-12 col-md-12 col-xl-12">
            <button class="flotanteDerecha accent" mat-raised-button type="button" (click)='Guardar()'>Guardar</button>
        </div>
    </div>
</div>
